import { Features } from 'generated/featureDefinitions'

import { useAccountsPayableUpsellModal } from 'modules/finance/hooks/useAccountsPayableUpsellModal'
import {
  UpsellSourceType,
  accountsPayableUpsellRequestProps,
} from 'modules/finance/lib/upsellUtils'
import { RequestUpgradeProps } from 'modules/upsell/lib/requestUpgradeTypes'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface AccountsPayableUpsellModalProps {
  source: UpsellSourceType
}

export const AccountsPayableUpsellModal = ({ source }: AccountsPayableUpsellModalProps) => {
  const { showAccountsUpsellModal, onClose } = useAccountsPayableUpsellModal(source)
  const requestProps: RequestUpgradeProps = accountsPayableUpsellRequestProps(source)

  return (
    <UpsellingKit.FeatureModal
      moduleRequested={requestProps.moduleRequested}
      requestSource={source}
      requestReason={requestProps.requestReason}
      featureRequested={requestProps.featureRequested || Features.accounts_payable_management}
      isOpen={!!showAccountsUpsellModal}
      onClose={onClose}
    />
  )
}
